import ajax from '@/modules/ajax';
import Formater from '@/modules/formater';

import { getStorage, removeStorage, setStorage } from '@/modules/storage';
import { addEnterListener, animateNumber, hide, integer, show } from '@/modules/helper';

const COUPON_KEY = 'coupon';

export default class Coupon {
  constructor(options) {
    this.options = options;
    this.namespace = [COUPON_KEY, options.namespace].join(':');

    this.couponWrapper = document.querySelector('[data-coupon-wrapper]');
    this.couponField = document.querySelector('[data-coupon-field]');
    this.couponButton = document.querySelector('[data-coupon-button]');

    this.showCouponFieldButton = document.querySelector('[data-show-coupon-field-button]');
    this.removeCouponButton = document.querySelector('[data-remove-coupon-button]');

    this.couponCodeField = document.querySelector('[data-coupon-code-field]');
    this.couponCodeLabel = document.querySelector('[data-coupon-code-label]');
    this.discountText = document.querySelector('[data-discount-text]');

    this.couponableIdField = document.querySelector('[data-couponable-id-field]');
    this.couponableTypeField = document.querySelector('[data-couponable-type-field]');
    this.subtotalField = document.querySelector('[data-subtotal-field]');

    this.totalText = document.querySelector('[data-total]');
    this.totalInitialField = document.querySelector('[data-total-initial-field]');

    this.extraCentsFields = document.querySelectorAll('[data-extra-cents-field]');
  }

  bind() {
    this.showCouponFieldButton.addEventListener('click', this.handleShow.bind(this));
    this.removeCouponButton.addEventListener('click', this.handleRemove.bind(this));

    this.couponButton.addEventListener('click', (evt) => {
      evt.preventDefault();

      this.handleApply();
    });

    addEnterListener(this.couponField, this.handleApply.bind(this));
  }

  clearDiscountLabels() {
    document.querySelectorAll('[data-item-price].discounted').forEach((discountedItem) => {
      discountedItem.classList.remove('discounted');
    });
  }

  done(json) {
    this.fill(json);
    this.handleHide();

    setStorage(this.namespace, json.code);

    show(this.removeCouponButton);
  }

  extraCents() {
    let total = 0;

    this.extraCentsFields.forEach((field) => {
      total += integer(field.value || 0);
    });

    return total;
  }

  fill(json) {
    this.clearDiscountLabels();

    if (json.code) {
      this.couponCodeField.value = json.code;
      this.couponCodeLabel.innerText = `(${json.code})`;
    } else {
      this.couponCodeField.value = '';
      this.couponCodeLabel.innerText = '';
    }

    this.couponField.value = '';

    const total = json.subtotal_cents - json.discount_cents + this.extraCents();

    const isDiscountExceeded = total < 0;

    this.setDiscountText(json.discount_cents);

    if (isDiscountExceeded) {
      this.totalText.innerText = Formater.money(0);
    } else {
      const absoluteTotal = Math.abs(total);

      animateNumber(this.totalText, absoluteTotal, (value) => Formater.money(value));
    }

    if (json.items) this.fillItems(json);
  }

  fillItems(json) {
    const wrappers = document.querySelectorAll('[data-item-price]');

    wrappers.forEach((wrapper) => {
      const itemId = wrapper.dataset.itemId;
      const itemData = json.items[itemId];

      if (itemData) {
        const discountElement = wrapper.querySelector('[data-ticket-discount]');

        discountElement.innerText = Formater.money(itemData.total_cents);

        wrapper.classList.add('discounted');
      } else {
        wrapper.classList.remove('discounted');
      }
    });
  }

  handleApply() {
    ajax({
      body: {
        coupon_code: this.couponField.value,
        couponable_id: this.couponableIdField.value,
        couponable_type: this.couponableTypeField.value,
        item_ids: this.options.itemIds,
        item_type: this.options.itemType,
        value: this.subtotalField.value,
      },
      fail: this.fail.bind(this),
      done: this.done.bind(this),
      method: 'POST',
      url: this.couponButton.dataset.url,
    });
  }

  fail(json) {
    removeStorage(this.namespace);
  }

  handleRemove() {
    removeStorage(this.namespace);
    hide(this.removeCouponButton);

    this.fill({
      code: undefined,
      discount_cents: 0,
      subtotal_cents: integer(this.subtotalField.value),
      total_cents: integer(this.totalInitialField.value),
    });
  }

  handleShow() {
    hide(this.showCouponFieldButton);
    show(this.couponWrapper);

    this.couponField.focus();
  }

  handleHide() {
    show(this.showCouponFieldButton);
    hide(this.couponWrapper);
  }

  init() {
    if (this.couponButton) {
      this.bind();
      this.readCache();
    }
  }

  readCache() {
    const code = getStorage(this.namespace);

    if (code) {
      this.couponField.value = code;

      this.handleApply();
    }
  }

  setDiscountText(cents) {
    animateNumber(this.discountText, cents, (value) => Formater.money(value === 0 ? 0 : -value));
  }
}
